import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Videochat: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={53}
    height={53}
    viewBox="0 0 53 53"
    fill="none"
    {...props}
  >
    <defs>
      <clipPath id="videochat_clip0">
        <rect width="53" height="53" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#videochat_clip0)">
      <path
        d="M50.6701 10.4847L39.75 15.3463V28.443L50.6693 33.3111C51.7648 33.7996 52.9999 32.9978 52.9999 31.7985V11.9979C52.9999 10.7989 51.7654 9.99709 50.6701 10.4847Z"
        fill="#002677"
      />
      <path
        d="M33.125 5.29999H3.31252C1.48314 5.29999 0 6.78299 0 8.6125V35.1125C0 36.9419 1.483 38.425 3.31252 38.425H8.39406L19.2072 47.7845C19.4686 48.0108 19.875 47.8251 19.875 47.4794V38.425H33.1249C34.9543 38.425 36.4374 36.942 36.4374 35.1125V8.6125C36.4376 6.78312 34.9544 5.29999 33.125 5.29999Z"
        fill="#FF612B"
      />
    </g>
  </Box>
)

export default Videochat
